import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createRulesFailed, createRulesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import RulesDTO from '../../../dto/RulesDTO';

export default function* createRules(action) {
  try {
    const url = `${BACKEND_URL}/rules`;
    const pool = new RulesDTO(action.payload).getData();
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createRulesSuccessful());
      yield call(resolveActionPromise(action, data.rule));
    } else {
      const data = yield getBodyJson(response);
      yield put(createRulesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createRulesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
